import React from 'react';

const IconBase = ({ children, size = 20, className = '', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    {children}
  </svg>
);

export const TableroIcon = props => (
  <IconBase {...props}>
    <rect x="3" y="3" width="7" height="7" rx="1.7" />
    <rect x="14" y="3" width="7" height="7" rx="1.7" />
    <rect x="3" y="14" width="7" height="7" rx="1.7" />
    <rect x="14" y="14" width="7" height="7" rx="1.7" />
  </IconBase>
);

export const FacturacionIcon = props => (
  <IconBase {...props}>
    <path d="M6 2.5h8l4 4v15H6z" />
    <path d="M14 2.5v4h4" />
    <path d="M9.2 10.1h2.2a1.6 1.6 0 0 1 0 3.2H10a1.6 1.6 0 0 0 0 3.2h2.3" />
    <path d="M10.8 8.8v9" />
    <path d="M14.8 11.3h1.2M14.8 15.2H16" />
  </IconBase>
);

export const HorariosIcon = props => (
  <IconBase {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l4-2.8" />
    <path d="M12 3v1M21 12h-1M12 21v-1M3 12h1" />
  </IconBase>
);

export const PrestamosIcon = props => (
  <IconBase {...props}>
    <circle cx="12" cy="6.3" r="3.4" />
    <path d="M12 3.9v4.8M13.5 4.8h-2a1 1 0 0 0 0 2h1a1 1 0 0 1 0 2h-2" />
    <path d="M3 15.8h3.2l2.2-2.1c.5-.5 1.1-.7 1.8-.7h3.4a1.5 1.5 0 0 1 0 3h-2.3" />
    <path d="m13.2 15.9 4.3-3.2a1.7 1.7 0 0 1 2.3 2.5l-5.4 4.2a3 3 0 0 1-1.8.6H7l-1.8 1H3z" />
  </IconBase>
);

export const SolicitudesIcon = props => (
  <IconBase {...props}>
    <path d="M8 5H5.5A1.5 1.5 0 0 0 4 6.5v14h13v-3" />
    <path d="M9 5V3.8h4V5h2v3H7V5z" />
    <circle cx="8" cy="11" r=".7" fill="currentColor" stroke="none" />
    <circle cx="8" cy="15" r=".7" fill="currentColor" stroke="none" />
    <path d="M10.5 11h3M10.5 15h1.5" />
    <path d="m13.2 18.8.7-2.6 5.5-5.5 1.9 1.9-5.5 5.5z" />
  </IconBase>
);

export const UsuariosIcon = props => (
  <IconBase {...props}>
    <circle cx="9" cy="8" r="3.3" />
    <path d="M2.8 20v-1.2A5.8 5.8 0 0 1 8.6 13h.8a5.8 5.8 0 0 1 5.8 5.8V20z" />
    <circle cx="17.3" cy="9.2" r="2.4" />
    <path d="M15.5 14.2h1.8a4 4 0 0 1 4 4V20h-4" />
  </IconBase>
);
